import { useEffect, useRef, useState } from 'react';
import './Ourhistory.css'
import { useTranslation } from 'react-i18next';

function Ourhistory() {

    const {t} = useTranslation()
    
    return (
        <section className="container-lg firm-description" id='section_1'>
            <div className="row h-100">
                <div className="col-md d-flex justify-content-center align-items-center" id='firm-description__left' data-aos="fade-up" >
                    <img src="images/zdjtest.svg" className='img-fluid' alt="Kamieniarstwo" />
                </div>
                <div className="col d-flex flex-column justify-content-center align-items-center" id='firm-description__right' data-aos="fade-up">
                    <h3 style={{ display: 'block', textAlign: 'center' }} className='fw-bold m-0 p-0 w-100 my-3'>Kam-Tech</h3>
                    <p>{t("ourhistory.text1")} <span className='underline'>2018</span>{t("ourhistory.text2")}<ins className='underline fw-bold'>{t("ourhistory.text3-1")}</ins>, <ins className='underline fw-bold'>{t("ourhistory.text3-2")}</ins> {t("ourhistory.text3-2-1")} <ins className='underline fw-bold'>{t("ourhistory.text3-3")}</ins>. {t("ourhistory.text3")}</p>
                </div> 
            </div>
        </section>
    )
}

export default Ourhistory